var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 22.6001L1 22.6001L1 19.6001L19 19.6001L19 22.6001ZM3.4 10.6001L8 10.6001L8 1.0001L12 1.0001L12 10.6001L16.6 10.6001L10 18.2354L3.4 10.6001Z",
    fill: "#329DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueload);
export default __webpack_public_path__ + "static/media/blueload.cb922b0d67f15cb12c85ad27d6629d67.svg";
export { ForwardRef as ReactComponent };